import classNames from 'classnames/bind';
import styles from './Filter.module.css';
import { ALL, FILTER } from '../../constants';
import { useEffect, useRef, useState } from 'react';
import { useSelect } from '../../hooks/useSelect';
import { TooltipWrapper } from '../Tooltip';

interface Filter {
  list: any[];
  onCheck: (checkedList: { [name: string]: string[] }) => void;
}

export default function Filter({ list, onCheck }: Filter) {
  const cx = classNames.bind(styles);

  const [isShow, setIsShow] = useState(false);
  const [checkedList, setCheckedList] = useState<{ [name: string]: string[] }>(
    {}
  );

  const buttonRef = useRef(null);
  const inpurRef = useRef(null);

  const handleCheckBoxChange = (
    name: string,
    value: string,
    list: string[]
  ) => {
    const curValues = checkedList[name];
    if (curValues?.includes(value)) {
      setCheckedList({
        ...checkedList,
        [name]: curValues.filter((val) => val !== value),
      });
    } else {
      setCheckedList({
        ...checkedList,
        [name]: value.includes(ALL)
          ? [value]
          : curValues?.length + 1 === list.length - 1
          ? [list[0]]
          : [
              ...(curValues ? curValues.filter((val) => val !== list[0]) : []),
              value,
            ],
      });
    }
  };

  useSelect(buttonRef, () => setIsShow(false));

  useEffect(() => {
    onCheck(checkedList);
  }, [checkedList]);

  function ItemList({ name, list }: { name: string; list: string[] }) {
    return (
      <ul className={cx('filter_list')}>
        {list.map((value: string, i) => (
          <li key={`${name}_${value}`}>
            <label htmlFor={`${name}_${value}`}>
              <input
                type="checkbox"
                id={`${name}_${value}`}
                name={name}
                className={cx('blind')}
                onChange={() => handleCheckBoxChange(name, value, list)}
                checked={
                  checkedList[name]?.includes(value) ||
                  ((!checkedList[name] || !checkedList[name].length) && i === 0)
                }
                ref={inpurRef}
              />
              <span className={cx('clabel')}>{value}</span>
            </label>
          </li>
        ))}
      </ul>
    );
  }

  return (
    <div className={cx('option_filter')} ref={buttonRef}>
      <div className={cx('btn_wrap')}>
        <TooltipWrapper content={FILTER} onClick={() => setIsShow(!isShow)}>
          {(tooltipProps) => (
            <button
              className={cx('btn', 'ico_filter')}
              {...tooltipProps}
            ></button>
          )}
        </TooltipWrapper>
        <span className={cx('blind')}>{FILTER}</span>
      </div>

      {isShow && (
        <div className={cx('filter_layer')}>
          <div className={cx('filter_area')}>
            {list.map(({ name, values }) => (
              <ItemList key={name} name={name} list={values} />
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
